import { AssetCardProps } from 'features/assetDatabase/types/assetCardTypes'
import { AssetImageGenerator } from 'features/assetViz'
import React from 'react'

interface AssetTableAssetVizProps {
  unitID: string
  siteID: string
  cardProps: AssetCardProps | undefined
}

export const AssetTableAssetViz: React.FC<AssetTableAssetVizProps> = (
  props
) => {
  const { unitID, cardProps } = props
  return (
    <>
      {cardProps?.unit && (
        <AssetImageGenerator
          assetVizID={unitID}
          unit={cardProps.unit}
          assetModel={cardProps?.assetModel}
          component={cardProps?.component}
          getColorThresholdForComponent={
            cardProps?.getColorThresholdForComponent
          }
          componentDataFrame={cardProps?.componentDataFrame}
        />
      )}
    </>
  )
}
